export const validatePeselNumber = (pesel: string): boolean | string => {

    if (!pesel || pesel.length !== 11) {
        return false;
    }

    let weight: number[] = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
    let sum: number = 0;
    let controlNumber: number = +pesel.substring(10, 11);

    for (let i: number = 0; i < weight.length; i++) {
        sum += (+pesel.substring(i, i + 1) * weight[i]);
    }

    sum = sum % 10;

    return (10 - sum) % 10 === controlNumber;

};


export default validatePeselNumber;
